module.exports = __webpack_public_path__ + "static/media/nurse_accredited6.ce7c9c9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nurse_accredited6.png
// module id = 485
// module chunks = 0